/**
 * Unified Header Component
 * Consistent header layout for all management pages
 */

import React from 'react';
import './UnifiedHeader.css';

const UnifiedHeader = ({
    title,
    subtitle,
    icon,
    count,
    countLabel,
    selectedCount,
    selectedLabel,
    children
}) => {
    return (
        <div className="unified-header">
            <div className="unified-header-content">
                <div className="unified-title-section">
                    <div className="unified-icon">
                        <span className="icon">{icon}</span>
                    </div>
                    <div className="unified-title-info">
                        <h2>{title}</h2>
                        <p>{subtitle}</p>
                        <div className="unified-count">
                            <span className="count-number">{count}</span>
                            <span className="count-label">{countLabel}</span>
                        </div>
                    </div>
                </div>

                <div className="unified-actions-section">
                    {selectedCount > 0 && (
                        <div className="unified-selection-info">
                            <div className="unified-selection-count">
                                <span className="selected-number">{selectedCount}</span>
                                <span className="selected-label">{selectedLabel}</span>
                            </div>
                        </div>
                    )}
                    {children}
                </div>
            </div>
        </div>
    );
};

export default UnifiedHeader;
